import { render, staticRenderFns } from "./modifyMailingMethodModal.vue?vue&type=template&id=5f986b8e&scoped=true"
import script from "./modifyMailingMethodModal.vue?vue&type=script&lang=js"
export * from "./modifyMailingMethodModal.vue?vue&type=script&lang=js"
import style0 from "./modifyMailingMethodModal.vue?vue&type=style&index=0&id=5f986b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f986b8e",
  null
  
)

export default component.exports